<wbo-edit-page #editPage [title]="model.data.name" [formGroup]="editPage.formGroup">
    <fui-rows>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name"></wbo-text-edit-control>
                </fui-column>
                <fui-column>
                    <wbo-text-edit-control formControlName="preparationTime" [(ngModel)] = "model.data.preparationTime"></wbo-text-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </fui-rows>
</wbo-edit-page>
